var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.mobile = new (function () {
    var self = this;
    this.init = function () {
        this.setupMenu();
        this.widgetAppend();
    };

    this.setupMenu = function () {
        var winWidth = window.innerWidth;

        //Extranet menu (Always mobile)

        $("#js-menu-toggle").unbind("click");
        $(".js-sub-mobile-nav").unbind("click");
        $(".header-actions-search").unbind("click");
        $(".dim-overlay").unbind("click");
        $(".mini-nav-show-search").unbind("click");

        // $(".mobile-search").append($(".mini-nav-search"));
        $(".js-sub-mobile-nav").click(function () {
            $(this)
                .siblings(".extranet-nav-sublist")
                .addClass(".extranet-nav-sublist--open");
            $(this).siblings(".extranet-nav-sublist").stop().slideToggle();
            $(this).children("svg").toggleClass("rotate");
            $(this).toggleClass("extranet-nav-list-item-button--active");
        });
        $(".js-sub-mobile-login").click(function () {
            $(this)
                .siblings(".extranet-nav-sublist")
                .addClass(".extranet-nav-sublist--open");
            $(this).siblings(".extranet-nav-sublist").stop().slideToggle();
            $(this)
                .siblings(".js-sub-mobile-nav")
                .children("svg")
                .toggleClass("rotate");
            $(this)
                .siblings(".js-sub-mobile-nav")
                .toggleClass("extranet-nav-list-item-button--active");
        });
        $(".header-actions-search").on("click", function () {
            $(".mobile-search").toggleClass("mobile-search--show");
            if ($(".mobile-search").hasClass("mobile-search--show")) {
                $(".ticket-list")
                    .find(".mobile-search-result.mobile-search-result--show")
                    .removeClass("mobile-search-result--show");
            }
            $(".js-search-input").focus();
            if ($(".nav-main-mobile").hasClass("nav-main-mobile--show")) {
                $(".nav-main-mobile").removeClass("nav-main-mobile--show");
            } else {
                $(".dim-overlay").toggleClass("fade");
            }
        });

        $("#js-menu-toggle").on("click", function () {
            $(".nav-main-mobile").toggleClass("nav-main-mobile--show");
            $("body").toggleClass("body-overflow--hidden");
            $(".notifications").css("display", "none");
            $(".header-logo-link").toggleClass("header-logo-link--show");
            if ($(".mobile-search").hasClass("mobile-search--show")) {
                $(".mobile-search").removeClass("mobile-search--show");
            } else {
                $(".dim-overlay").toggleClass("fade");
            }
        });

        $(".header-container__link").on("click", function () {
            var pathName = window.location.pathname.split("/");
            var pathSecond = pathName[2];
            if ($("body").hasClass("body-overflow--hidden") && pathSecond) {
                $(".header-logo-link").toggleClass("header-logo-link--show");
                if ($(".mobile-search").hasClass("mobile-search--show")) {
                    $(".mobile-search").removeClass("mobile-search--show");
                } else {
                    $(".dim-overlay").toggleClass("fade");
                }
            } else if ($("body").hasClass("body-overflow--hidden")) {
                $(".nav-main-mobile").toggleClass("nav-main-mobile--show");
                $("body").toggleClass("body-overflow--hidden");
            }
        });

        $(".dim-overlay").on("click", function () {
            $(".mobile-search").removeClass("mobile-search--show");
            $(".dim-overlay").removeClass("fade");
            $(".nav-main-mobile").removeClass("nav-main-mobile--show");
            $(".header-logo-link").removeClass("header-logo-link--show");
            $(".js-help-popup").fadeOut();
        });

        //Mobile menu

        if (winWidth < 992) {
            $(".mobile-menu-footer-links").append(
                $(".footer-links").find(".footer-links__item")
            );
            $(".mobile-menu-header-links").append(
                $(".mini-nav-language-picker-button")
            );
            $(".mobile-menu-header-links").append(
                $(".mini-nav-accessibility-button")
            );
            $("#js-menu-toggle").unbind("click");
            //$('.js-sub-mobile-nav').unbind('click');
            $(".sub-menu-toggle").unbind("click");
            $(".dim-overlay").unbind("click");

            $(".mobile-menu-back-button").click(function () {
                $(".mobile-menu-back-button-container").removeClass(
                    "mobile-menu-back-button-container--open"
                );
                $(".nav-main-mobile-sublist").removeClass(
                    "nav-main-mobile-sublist--open"
                );
            });
            $(".js-sub-mobile-nav").on("click", function () {
                $(this).siblings(".nav-main-mobile-sublist").slideToggle();
                $(this).toggleClass("rotated");
            });
            $("#js-menu-toggle").on("click", function () {
                $(".nav-main-mobile").toggleClass("nav-main-mobile--show");
                $(".header-logo-link").toggleClass("header-logo-link--show");
                $("body").toggleClass("body-overflow--hidden");
                $(".notifications").css("display", "none");

                if ($(".mobile-search").hasClass("mobile-search--show")) {
                    $(".mobile-search").removeClass("mobile-search--show");
                    $("body").css("overflow", "hidden");
                } else {
                    $(
                        ".mobile-search-result.mobile-search-result--show"
                    ).removeClass("mobile-search-result--show");
                    $(".dim-overlay").toggleClass("fade");
                }
            });
            $(".mini-nav-show-search").on("click", function () {
                $(".mobile-search").toggleClass("mobile-search--show");
                $(".js-search-input").focus();
                if ($(".nav-main-mobile").hasClass("nav-main-mobile--show")) {
                    $(".nav-main-mobile").removeClass("nav-main-mobile--show");
                } else {
                    $(".dim-overlay").toggleClass("fade");
                }
            });
            $(".dim-overlay").on("click", function () {
                $(".mobile-search").removeClass("mobile-search--show");
                $(".dim-overlay").removeClass("fade");
                $(".nav-main-mobile").removeClass("nav-main-mobile--show");
                $(".header-logo-link").removeClass("header-logo-link--show");
                $(".js-help-popup").fadeOut();
            });

            $(".sub-menu-toggle").on("click", function () {});
        }

        //Desktop menu
        else if (winWidth >= 992) {
            $(".footer-links").append(
                $(".mobile-menu-footer-links").children(".footer-links__item")
            );
            $(".mini-nav-language-picker").append(
                $(".mini-nav-language-picker-button")
            );
            $(".mini-nav-accessibility").append(
                $(".mini-nav-accessibility-button")
            );
            $(".sub-menu-toggle").unbind("click");
        }
    };

    this.widgetAppend = function () {
        var winWidth = window.innerWidth;

        if (winWidth < 992) {
            $(".frontpage-hero-content .frontpage-hero-rejseplanen-container")
                .insertBefore(".widgets")
                .addClass("mobile-mode");
        } else {
            $(".frontpage-hero-rejseplanen-container")
                .insertAfter(".frontpage-hero-search-container")
                .removeClass("mobile-mode");
        }
    };
})();
